const routes = [
    {
        path: '/contabilidade/dominio_sistemas/configuracoes/index/:hash',
        component: () => import('../views/Gerais'),
    },
]

export default routes